var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCurveDownRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3952_29665",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3952_29665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.125 14.791C13.9444 14.791 13.7952 14.7321 13.6775 14.6143C13.5591 14.496 13.5 14.3466 13.5 14.166C13.5 13.9855 13.5591 13.836 13.6775 13.7177C13.7952 13.5999 13.9444 13.541 14.125 13.541H15.9791L11.125 8.74935L8.31246 11.5618C8.24302 11.6313 8.16329 11.6832 8.07329 11.7177C7.98274 11.7527 7.88885 11.7702 7.79163 11.7702C7.6944 11.7702 7.60052 11.7527 7.50996 11.7177C7.41996 11.6832 7.34024 11.6313 7.27079 11.5618L2.33329 6.58268C2.22218 6.47157 2.16663 6.33268 2.16663 6.16602C2.16663 5.99935 2.22913 5.85352 2.35413 5.72852C2.47913 5.60352 2.62496 5.54102 2.79163 5.54102C2.95829 5.54102 3.10413 5.60352 3.22913 5.72852L7.79163 10.291L10.6041 7.47852C10.6736 7.40907 10.7536 7.35685 10.8441 7.32185C10.9341 7.2874 11.0277 7.27018 11.125 7.27018C11.2222 7.27018 11.3161 7.2874 11.4066 7.32185C11.4966 7.35685 11.5763 7.40907 11.6458 7.47852L16.8333 12.666V10.8327C16.8333 10.6521 16.8925 10.5027 17.0108 10.3843C17.1286 10.2666 17.2777 10.2077 17.4583 10.2077C17.6388 10.2077 17.7883 10.2666 17.9066 10.3843C18.0244 10.5027 18.0833 10.6521 18.0833 10.8327V14.041C18.0833 14.2493 18.0105 14.4266 17.865 14.5727C17.7188 14.7182 17.5416 14.791 17.3333 14.791H14.125Z",
    fill: "#FE6666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCurveDownRed);
export default __webpack_public_path__ + "static/media/arrow_curve_down_red.2c21ef0d9be27f0679a109994a972b90.svg";
export { ForwardRef as ReactComponent };